import { List, Record } from 'immutable';
import { THREAD_REMOVAL_TYPE } from './threadRemovalKeyPaths';
import { THREAD_STATUS } from './threadRemovalTypes';
const ThreadStatusRemoval = Record({
  [THREAD_REMOVAL_TYPE]: THREAD_STATUS,
  audit: null,
  members: List(),
  status: null
}, 'ThreadStatusRemoval');
export default ThreadStatusRemoval;